import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../constants';
// Optional: uncomment if you want to auto-logout on 401
// import { logout } from './authSlice';

// Remove empty/falsey query params so /api/orders?q=&invoice= becomes clean
const cleanParams = (obj = {}) => {
  const out = {};
  Object.entries(obj).forEach(([k, v]) => {
    if (
      v !== '' &&
      v !== null &&
      v !== undefined &&
      // keep 0 / false (they may be meaningful)
      !(typeof v === 'string' && v.trim() === '')
    ) {
      out[k] = v;
    }
  });
  return out;
};

const rawBaseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  credentials: 'include',
  prepareHeaders: (headers, { getState }) => {
    const token = getState()?.auth?.userInfo?.token;
    if (token) headers.set('authorization', `Bearer ${token}`);
    return headers;
  },
});

// Wrap to clean params + centralize 401 handling
const baseQuery = async (args, api, extraOptions) => {
  let nextArgs = args;

  // If caller used object form with params, prune them
  if (typeof args === 'object' && args !== null && 'params' in args) {
    nextArgs = { ...args, params: cleanParams(args.params) };
  }

  const result = await rawBaseQuery(nextArgs, api, extraOptions);

  // Optional: central 401 handling
  if (result.error && result.error.status === 401) {
    // api.dispatch(logout()); // uncomment if you imported logout
  }

  return result;
};

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery,
  // Add any tag types you plan to provide/invalidate
  tagTypes: [
    'Product',
    'User',
    'VehicleMakes',
    'FitmentFacets',
    'PartCategories',
    'Order',
    'Invoice',
    'Upload',
    'ReturnRequest',
    'PartnerCodes',
    'PartnerRedemptions',
    'PricingTiers',
    'ProductTierPrices',
    'MonthlyStatement',
  ],
  endpoints: () => ({}),
});
